import { Button } from 'antd'
import React, { useState } from 'react'
import TextArea from 'antd/es/input/TextArea'
import { useParams } from 'react-router-dom'
import { BODY_PARTS } from '../../../constants'
import { BodyPartSelector, VERTICAL } from './BodyPartSelector'
import { FormLabel } from '../../../components/form/FormLabel'
import { useReactivateSubject } from '../../../hooks/useSubject'

type Props = {
  subject: any
  onClose?: () => void
}

export const ReactivateSubjectDrawer = ({ subject, onClose = () => {} }: Props) => {
  const { projectId, siteId } = useParams() as { projectId: string; siteId: string }

  const [reActivateReason, setReActivateReason] = useState<string>('')

  const currentPhase = subject && subject.currentPhase ? subject.currentPhase : {}

  const [selectedBodyParts, setSelectedBodyParts] = useState<string>()

  const { callReactivate, isLoading } = useReactivateSubject(projectId, subject._id, siteId)

  const plainOptions = currentPhase?.bodyParts
    ? currentPhase.bodyParts.map((item) => {
        return { bodyPart: item, label: BODY_PARTS[item] || item }
      })
    : []

  console.log('ReactivateSubjectDrawer > plainOptions = ', plainOptions)

  const hideContent = () => {
    setReActivateReason('')
    onClose()
  }

  const handleReactivation = () => {
    const obj = {
      projectId: projectId,
      subjectId: subject._id,
      reasonDescription: reActivateReason,
      bodyPart: selectedBodyParts,
    }

    return callReactivate(obj)
      .then(() => {
        setReActivateReason('')

        onClose()
      })
      .catch((error) => {
        alert(error.message)
      })
  }

  const hasReason = reActivateReason.length < 5 ? false : true

  const canMove = selectedBodyParts !== undefined && hasReason

  return (
    <div className="container-fluid h-100 d-flex flex-column">
      <div className="d-flex align-items-center mb-2">
        <h4 className="mb-0">Subject reactivation</h4>
      </div>

      {currentPhase?.bodyParts?.length !== 0 ? (
        <>
          <p className="mt-2">
            Reactivate this subject and resume ePRO data collection. The subject will return to their previous phase.
            The subject’s device will be re-enabled to continue study participation.
          </p>

          <BodyPartSelector
            bodyparts={plainOptions}
            direction={VERTICAL}
            setSelectedBodyPart={setSelectedBodyParts}
          ></BodyPartSelector>
        </>
      ) : (
        <>
          <p className="mt-2">
            Reactivate this subject and resume ePRO data collection. Provide a written reason below. The subject will
            return to their previous phase.
          </p>
          <p className="mt-3 mb-2">The subject’s device will be re-enabled to continue study participation.</p>
        </>
      )}

      <FormLabel label="Provide justification:"></FormLabel>
      <TextArea
        placeholder=""
        rows={2}
        className="mt-1"
        onChange={(e) => setReActivateReason(e.target.value)}
        value={reActivateReason}
      />

      <div style={{ marginTop: 24, textAlign: 'right' }}>
        <Button onClick={hideContent}>Cancel</Button>

        <Button
          className="ms-2"
          type="primary"
          loading={isLoading}
          onClick={handleReactivation}
          disabled={reActivateReason.length < 5 || plainOptions.length > 0 ? !canMove : false}
        >
          Reactivate Subject
        </Button>
      </div>
    </div>
  )
}
